<template>
  <div class="error">
    <div class="content">
      <img :src="errorImg" alt="error">
      <div class="err-msg">
        <h3 class="err-title">{{title}}!</h3>
        <div class="err-body">
          <p>可能原因</p>
          <div>
            <ul>
              <li>网络信号弱</li>
              <li>权限不足</li>
              <li>网站维护</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="button-group">

      <a :href="config.adminHost+'login'">
        <span>
          <i class="iconfont icon-refresh">
          </i><a :href="config.adminHost+'leemmaCustomer'">重新登陆</a></span>
      </a>
      <!-- <a href="#" onclick="history.back(-1)">
        <span>
          <i class="iconfont icon-fanhui"></i>返回上一页</span>
      </a> -->

    </div>
  </div>
</template>

<script>
import errorImg from '../assets/images/error.svg'
import Lib from '../lib/lib'
export default {
  name: "error",
  data() {
    return {
      errorImg,
      error_code: '',
      title: '无法访问',
      config: Lib.C
    }

  },
  created() {
    this.error_code = this.$route.query.error
    if (this.error_code === '401') {
      this.title = '权限不足,无法访问'

    }
  }
}
</script>

<style scoped>
.error img {
  height: 240px;
}

.error {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content {
  display: flex;
  justify-content: center;
}

.err-msg {
  margin-left: 62px;
}

.err-msg>.err-title {
  font-size: .22rem;
  padding: 32px 0;
  text-align: center;
  margin-bottom: 32px;
  border-bottom: 1px solid #ccc;
}

.err-body {
  display: flex;
  padding: 0 50px;
  font-size: 18px;
}

.err-body>p {
  margin-right: 62px;
  line-height: 1.4;
}

.err-body li {
  list-style: initial;
  line-height: 1.4;
}

.button-group {
  color: #057efb;
  display: flex;
  font-size: .18rem;
    margin: 50px 0;
  width: 50%;
  justify-content: center;
}
.button-group a{
  color: #057efb;

}
.button-group i {
  margin-right: 15px;
  font-size: .2rem;
}

@media (max-width: 1000px) {
  .error img {
       height: 120px;
  }
  .content {
    flex-direction: column;
    align-items: center;
  }
  .err-msg>.err-title {
    font-size: 18px;
  }
  .err-body {
    font-size: 15px;
  }
  .err-msg {
    margin-left: 0;
  }
  .button-group {
    font-size: .15rem;
    width: 80%;
    font-size: .15rem;
  }
  .button-group i {
    margin-right: 5px;
    font-size: .2rem;
  }
}
</style>



// WEBPACK FOOTER //
// error.vue?60f082e3